
const devicon = {
    "Adonisjs": "adonisjs-original",
    "Aftereffects": "aftereffects-plain",
    "Amazonwebservices": "amazonwebservices-original",
    "Android": "android-plain",
    "Androidstudio": "androidstudio-plain",
    "Aarch64": "aarch64-plain",
    "Angularjs": "angularjs-plain",
    "Ansible": "ansible-plain",
    "Apache": "apache-plain",
    "Apachekafka": "apachekafka-original",
    "Appcelerator": "appcelerator-original",
    "Apple": "apple-original",
    "Appwrite": "appwrite-plain",
    "Arduino": "arduino-plain",
    "Atom": "atom-original",
    "Azure": "azure-plain",
    "Babel": "babel-plain",
    "Backbonejs": "backbonejs-plain",
    "Bamboo": "bamboo-original",
    "Bash": "bash-plain",
    "Behance": "behance-plain",
    "Bitbucket": "bitbucket-original",
    "Bootstrap": "bootstrap-plain",
    "Bulma": "bulma-plain",
    "Bower": "bower-plain",
    "C": "c-plain",
    "Cakephp": "cakephp-plain",
    "Canva": "canva-original",
    "Centos": "centos-plain",
    "Ceylon": "ceylon-plain",
    "Chrome": "chrome-plain",
    "Circleci": "circleci-plain",
    "Clojure": "clojure-line",
    "Cmake": "cmake-plain",
    "Clojurescript": "clojurescript-plain",
    "Codecov": "codecov-plain",
    "Codeigniter": "codeigniter-plain",
    "Codepen": "codepen-plain",
    "Coffeescript": "coffeescript-original",
    "Composer": "composer-line",
    "Confluence": "confluence-original",
    "Couchdb": "couchdb-plain",
    "Cplusplus": "cplusplus-plain",
    "Csharp": "csharp-plain",
    "Css3": "css3-plain",
    "Cucumber": "cucumber-plain",
    "Crystal": "crystal-original",
    "D3js": "d3js-plain",
    "Dart": "dart-plain",
    "Debian": "debian-plain",
    "Denojs": "denojs-original",
    "Devicon": "devicon-plain",
    "Django": "django-plain",
    "Docker": "docker-plain",
    "Doctrine": "doctrine-plain",
    "Dot-net": "dot-net-plain",
    "Dotnetcore": "dotnetcore-plain",
    "Drupal": "drupal-plain",
    "Digitalocean": "digitalocean-plain",
    "Discordjs": "discordjs-plain",
    "Electron": "electron-original",
    "Eleventy": "eleventy-plain",
    "Elixir": "elixir-plain",
    "Elm": "elm-plain",
    "Ember": "ember-original-wordmark",
    "Embeddedc": "embeddedc-plain",
    "Erlang": "erlang-plain",
    "Eslint": "eslint-original",
    "Express": "express-original",
    "Facebook": "facebook-plain",
    "Feathersjs": "feathersjs-original",
    "Figma": "figma-plain",
    "Filezilla": "filezilla-plain",
    "Firebase": "firebase-plain",
    "Firefox": "firefox-plain",
    "Flask": "flask-original",
    "Flutter": "flutter-plain",
    "Foundation": "foundation-plain",
    "Fsharp": "fsharp-plain",
    "Gatling": "gatling-plain",
    "Gatsby": "gatsby-plain",
    "Rect": "rect-plain",
    "Gcc": "gcc-plain",
    "Gentoo": "gentoo-plain-wordmark",
    "Gimp": "gimp-plain",
    "Git": "git-plain",
    "Github": "github-original",
    "Gitlab": "gitlab-plain",
    "Gitter": "gitter-plain",
    "Go": "go-original-wordmark",
    "Google": "google-plain",
    "Googlecloud": "googlecloud-plain",
    "Gradle": "gradle-plain",
    "Grafana": "grafana-original",
    "Grails": "grails-plain",
    "Graphql": "graphql-plain",
    "Groovy": "groovy-plain",
    "Grunt": "grunt-plain",
    "Gulp": "gulp-plain",
    "Godot": "godot-plain",
    "Haskell": "haskell-plain",
    "Handlebars": "handlebars-original",
    "Haxe": "haxe-plain",
    "Heroku": "heroku-original",
    "Html5": "html5-plain",
    "Hugo": "hugo-plain",
    "Ie10": "ie10-original",
    "Ifttt": "ifttt-original",
    "Illustrator": "illustrator-plain",
    "Inkscape": "inkscape-plain",
    "Intellij": "intellij-plain",
    "Ionic": "ionic-original",
    "Jamstack": "jamstack-original",
    "Jasmine": "jasmine-plain",
    "Java": "java-plain",
    "Javascript": "javascript-plain",
    "Jeet": "jeet-plain",
    "Jest": "jest-plain",
    "Jenkins": "jenkins-line",
    "Jetbrains": "jetbrains-plain",
    "Jira": "jira-plain",
    "Jquery": "jquery-plain",
    "Julia": "julia-plain",
    "Jupyter": "jupyter-plain",
    "Kaggle": "kaggle-original",
    "Karma": "karma-plain",
    "Kotlin": "kotlin-plain",
    "Knockout": "knockout-plain-wordmark",
    "Krakenjs": "krakenjs-plain",
    "Kubernetes": "kubernetes-plain",
    "Labview": "labview-plain",
    "Laravel": "laravel-plain",
    "Latex": "latex-original",
    "Less": "less-plain-wordmark",
    "Linkedin": "linkedin-plain",
    "Lua": "lua-plain",
    "Linux": "linux-plain",
    "Materialui": "materialui-plain",
    "Matlab": "matlab-plain",
    "Magento": "magento-original",
    "Markdown": "markdown-original",
    "Maya": "maya-plain",
    "Meteor": "meteor-plain",
    "Minitab": "minitab-plain",
    "Mocha": "mocha-plain",
    "Modx": "modx-plain",
    "Mongodb": "mongodb-plain",
    "Moodle": "moodle-plain",
    "Msdos": "msdos-line",
    "Mysql": "mysql-plain",
    "Neo4j": "neo4j-plain",
    "Nestjs": "nestjs-plain",
    "Networkx": "networkx-original",
    "Nextjs": "nextjs-original",
    "Nginx": "nginx-original",
    "Nixos": "nixos-plain",
    "Nodejs": "nodejs-plain",
    "Nodewebkit": "nodewebkit-plain",
    "Npm": "npm-original-wordmark",
    "Nuget": "nuget-original",
    "Numpy": "numpy-original",
    "Nuxtjs": "nuxtjs-plain",
    "Objectivec": "objectivec-plain",
    "Opera": "opera-plain",
    "Ocaml": "ocaml-plain",
    "Openal": "openal-plain",
    "Opengl": "opengl-plain",
    "Opensuse": "opensuse-plain",
    "Oracle": "oracle-original",
    "Pandas": "pandas-original",
    "Perl": "perl-plain",
    "Phalcon": "phalcon-plain",
    "Photoshop": "photoshop-plain",
    "Php": "php-plain",
    "Phpstorm": "phpstorm-plain",
    "Podman": "podman-plain",
    "Polygon": "polygon-plain",
    "Postgresql": "postgresql-plain",
    "Premierepro": "premierepro-plain",
    "Processing": "processing-plain",
    "Protractor": "protractor-plain",
    "Putty": "putty-plain",
    "Pycharm": "pycharm-plain",
    "Python": "python-plain",
    "Pytorch": "pytorch-original",
    "Raspberrypi": "raspberrypi-line",
    "Phoenix": "phoenix-plain",
    "Qt": "qt-original",
    "R": "r-original",
    "Rails": "rails-plain",
    "React": "react-original",
    "Redhat": "redhat-plain",
    "Redis": "redis-plain",
    "Redux": "redux-original",
    "Rocksdb": "rocksdb-plain",
    "Ruby": "ruby-plain",
    "Rubymine": "rubymine-plain",
    "Rust": "rust-plain",
    "Safari": "safari-plain",
    "Salesforce": "salesforce-plain",
    "Sdl": "sdl-plain",
    "Rstudio": "rstudio-plain",
    "Sass": "sass-original",
    "Scala": "scala-plain",
    "Selenium": "selenium-original",
    "Sequelize": "sequelize-plain",
    "Shopware": "shopware-original",
    "Shotgrid": "shotgrid-plain",
    "Sketch": "sketch-original",
    "Slack": "slack-plain",
    "Socketio": "socketio-original",
    "Solidity": "solidity-plain",
    "Sourcetree": "sourcetree-original",
    "Spring": "spring-plain",
    "Spss": "spss-plain",
    "Sqlalchemy": "sqlalchemy-plain",
    "Sqlite": "sqlite-plain",
    "Subversion": "subversion-original",
    "Microsoftsqlserver": "microsoftsqlserver-plain",
    "Ssh": "ssh-original",
    "Stylus": "stylus-original",
    "Svelte": "svelte-plain",
    "Swift": "swift-plain",
    "Symfony": "symfony-original",
    "Storybook": "storybook-plain",
    "Tailwindcss": "tailwindcss-original-wordmark",
    "Tensorflow": "tensorflow-original",
    "Terraform": "terraform-plain",
    "Threejs": "threejs-original",
    "Tomcat": "tomcat-line",
    "Tortoisegit": "tortoisegit-plain",
    "Towergit": "towergit-plain",
    "Travis": "travis-plain",
    "Thealgorithms": "thealgorithms-plain",
    "Trello": "trello-plain",
    "Twitter": "twitter-original",
    "Typescript": "typescript-plain",
    "Typo3": "typo3-plain",
    "Ubuntu": "ubuntu-plain",
    "Unity": "unity-original",
    "Unix": "unix-original",
    "Unrealengine": "unrealengine-original",
    "Uwsgi": "uwsgi-plain",
    "Vagrant": "vagrant-plain",
    "Vim": "vim-plain",
    "Visualstudio": "visualstudio-plain",
    "Vuejs": "vuejs-plain",
    "Vuestorefront": "vuestorefront-plain",
    "Vscode": "vscode-plain",
    "Webflow": "webflow-original",
    "Weblate": "weblate-plain",
    "Webpack": "webpack-plain",
    "Webstorm": "webstorm-plain",
    "Windows8": "windows8-original",
    "Woocommerce": "woocommerce-plain",
    "Wordpress": "wordpress-plain",
    "Xamarin": "xamarin-original",
    "Xcode": "xcode-plain",
    "Xd": "xd-plain",
    "Yarn": "yarn-original",
    "Yii": "yii-plain",
    "Yunohost": "yunohost-plain",
    "Zend": "zend-plain",
    "Zig": "zig-original",
    "Pytest": "pytest-plain",
    "Opencv": "opencv-plain",
    "Fastapi": "fastapi-plain",
    "K3s": "k3s-original",
    "Packer": "packer-original",
    "Anaconda": "anaconda-original",
    "Rspec": "rspec-original",
    "Argocd": "argocd-plain",
    "Prometheus": "prometheus-original",
    "Blender": "blender-original",
    "Dropwizard": "dropwizard-plain",
    "Vuetify": "vuetify-line",
    "Fedora": "fedora-plain"
}

export default devicon